import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';

@ComponentAsElement('v-input-element')
@Component({
  selector: 'v-input',
  templateUrl: './input.component.html',
  styleUrls: []
})
export class InputComponent  {
  @Input() placeholderVal;
  @Output() changeVal = new EventEmitter<string>();
  @Output() enterVal = new EventEmitter<string>();

  getChangeVal(val: string) {
    this.changeVal.emit(val);
  }

  valFromEnter(val: string) {
    this.enterVal.emit(val);
  }
}
